module.exports = __webpack_public_path__ + "static/media/Cairo-Black.e82d91b0.ttf";